<template>
  <transition name="modal">
    <div
      v-if="isOpen"
      class="panorama-modal"
      @[$panorama._clickEvent].self="$emit('close')"
    >
      <div class="panorama-modal__container">
        <div class="panorama-modal__header">
          <div class="panorama-modal__title"> {{ title }} </div>
          <div class="panorama-modal__subtitle"> {{ subtitle }} </div>
          <button
            class="panorama-modal__close button"
            @[$panorama._clickEvent]="$emit('close')"
          >
            <close-icon />
          </button>
        </div>
        <div :class="{
            'panorama-modal__content': true,
            'panorama-modal__content--fluid': fluid
        }">
          <slot />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CloseIcon from '@/components/icons/PanoramaCloseIcon'
export default {
  name: 'PanoramaModal',
  components: {
    CloseIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.panorama-modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  z-index: 100;
  &__container {
    position: relative;
    margin: auto;
    max-width: 377px;
    min-width: 285px;
    background: var(--panorama-background-color);
    border-radius: 8px;
    pointer-events: all;
    backdrop-filter: blur(8px);
    @media screen and (min-width: 1920px) {
      border-radius: 0.42vw;
      max-width: 19.65vw;
      min-width: 14.85vw;
    }
  }
  &__content {
    margin: 0 32px 32px 32px;
    @media screen and (min-width: 1920px) {
      margin: 0 1.67vw 1.67vw 1.67vw;
    }
    &--fluid {
      margin: 0 0 32px 0;
      @media screen and (min-width: 1920px) {
        margin: 0 0 1.67vw 0;
      }
    }
  }
  &__header {
    margin: 32px 0 0 32px;
    @media screen and (min-width: 1920px) {
      margin: 1.67vw 0 0 1.67vw;
    }
  }
  &__title, &__subtitle {
    font-family: var(--panorama-first-font);
    line-height: 130%;
    text-transform: uppercase;
  }
  &__title {
    font-weight: 700;
    font-size: 24px;
    color: var(--panorama-text-color);
    @media screen and (min-width: 1920px) {
      font-size: 1.25vw;
    }
  }
  &__subtitle {
    font-size: 14px;
    color: var(--panorama-subtitle-color);
    @media screen and (min-width: 1920px) {
      font-size: 0.75vw;
    }
  }
  &__close {
    position: absolute;
    top: 24px;
    right: 16px;
    @media screen and (min-width: 1920px) {
      top: 1.2vw;
      right: 0.8vw;
      & > svg {
        width: 1.65vw;
        height: 1.65vw;
      }
    }
  }
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .5s
}
.modal-enter, .modal-leave-to {
  opacity: 0
}
</style>
